export default {
  from: '起',
  perLesson: '/課次',
}
